module.exports = __webpack_public_path__ + "img/hero.509d573d.png";